import Heading from 'components/Heading'
import React from 'react'
import { useTranslation } from 'react-i18next'

const BargeTankSection = () => {
  const { t } = useTranslation()

  return (
    <div className="bunker-section__content">
      <Heading level={4}>{t('rob.survey.bunker.bargeTank')}</Heading>
      {/* TODO: add barge tank fields */}
    </div>
  )
}

export default BargeTankSection
